import React from 'react';
import classNames from 'classnames';
import ActionChip from '@components/core/ActionChip';
import { useTranslations } from '@components/context';
import './AutomationSummaryChip.less';

// One configured automation, as a chip. The Design System owns the chip itself
// (core/ActionChip); this keeps the automation wording and the class names the flow editor's
// stylesheet and the acceptance suite select on.
const AutomationSummaryChip = ({
    className,
    icon,
    label,
    content,
    onRemove,
    tooltipText,
    onClick,
}) => {
    const { t } = useTranslations();

    return (
        <ActionChip
            className={classNames('automation-summary-chip', className)}
            slotClassNames={{
                main: 'automation-summary-chip__main',
                remove: 'automation-summary-chip__remove',
            }}
            icon={icon}
            label={label}
            description={content}
            tooltip={tooltipText || undefined}
            removeLabel={t('Remove')}
            onClick={onClick}
            onRemove={typeof onRemove === 'function' ? onRemove : undefined}
        />
    );
};

export default AutomationSummaryChip;
